import { marked } from "marked";

marked.use({
  extensions: [
    {
      name: "colorOpen",
      level: "inline",
      start(src) {
        return src.indexOf("{color:");
      },
      tokenizer(src) {
        const match = /^\{color:([^}]+)\}/.exec(src);

        if (!match) return;

        return {
          type: "colorOpen",
          raw: match[0],
          color: match[1],
        };
      },
      renderer(token) {
        return `<span style="color:${token.color}">`;
      },
    },
    {
      name: "colorClose",
      level: "inline",
      start(src) {
        return src.indexOf("{color}");
      },
      tokenizer(src) {
        const match = /^\{color\}/.exec(src);

        if (!match) return;

        return {
          type: "colorClose",
          raw: match[0],
        };
      },
      renderer() {
        return "</span>";
      },
    },
    {
      name: "markOpen",
      level: "inline",
      start(src) {
        return src.indexOf("{mark:");
      },
      tokenizer(src) {
        const match = /^\{mark:([^}]+)\}/.exec(src);

        if (!match) return;

        return {
          type: "markOpen",
          raw: match[0],
          color: match[1],
        };
      },
      renderer(token) {
        return `<mark style="background-color:${token.color}">`;
      },
    },
    {
      name: "markClose",
      level: "inline",
      start(src) {
        return src.indexOf("{mark}");
      },
      tokenizer(src) {
        const match = /^\{mark\}/.exec(src);

        if (!match) return;

        return {
          type: "markClose",
          raw: match[0],
        };
      },
      renderer() {
        return "</mark>";
      },
    },
  ],
});
